import { foundationTabStyles } from '@genesislcap/foundation-ui';
import { neutralLayer2, neutralLayer4 } from '@microsoft/fast-components';
import { css } from '@microsoft/fast-element';
import { ColorHEX } from '../_common';
export const zeroTabStyles = (context, definition) => css `
  ${foundationTabStyles(context, definition)}
  :host {
    background-color: ${neutralLayer2};
    border-radius: calc(var(--control-corner-radius) * 2px) calc(var(--control-corner-radius) * 2px)
      0 0;
    border: calc(var(--stroke-width) * 1px) solid ${ColorHEX.lightGrey};
    box-shadow: 0 0 15px 0 rgb(0 0 0 / 30%);
    margin-right: 5px;
  }

  :host([aria-selected='true']),
  :host([aria-selected='true']:hover) {
    background-color: ${neutralLayer4};
    border-bottom: 1px solid var(--zero-card-fill-color);
  }

  :host([appearance='secondary']) {
    border-radius: 0;
    border: 0;
    box-shadow: none;
    margin-right: 0;
    background-color: var(--zero-card-fill-color);
  }
`;
